import { ArrowPathIcon } from '@heroicons/react/24/outline';
import {
  Button,
  Checkbox,
  Container,
  Divider,
  Group,
  Paper,
  rem,
  Stack,
  Text,
  Title,
} from '@mantine/core';
import React, { useState } from 'react';
import PromptManagement from '../../components/admin/PromptManagement';
import { IndexerService } from '../../services/indexerService';

export const OperationsAIManagement: React.FC = () => {
  const [isIndexing, setIsIndexing] = useState(false);
  const [indexError, setIndexError] = useState<string | null>(null);
  const [indexSuccess, setIndexSuccess] = useState<string | null>(null);
  const [forceIndex, setForceIndex] = useState(false);

  const handleIndexCVs = async () => {
    setIsIndexing(true);
    setIndexError(null);
    setIndexSuccess(null);
    try {
      const indexerService = new IndexerService();
      const result = await indexerService.indexFiles(forceIndex);
      setIndexSuccess(result.response);
    } catch (err) {
      console.error('Error indexing CVs:', err);
      setIndexError(
        err instanceof Error
          ? err.message
          : 'Failed to index CVs. Please try again.'
      );
    } finally {
      setIsIndexing(false);
    }
  };

  return (
    <Container size="xl" py="md">
      <Stack gap="md">
        <Stack gap="xs">
          <Title order={1}>AI Management</Title>
          <Text c="dimmed">
            Manage AI system prompts, configurations, and tools
          </Text>
        </Stack>
        <Stack gap="md">
          <Title order={2} size="h3">CV Indexing</Title>
          <Paper p="md" withBorder>
            <Stack>
              <Text size="sm">
                Index all CVs in the system. This process may take some time
                depending on the number of CVs.
              </Text>
              <Group align="center">
                <Checkbox
                  label="Force reindex"
                  checked={forceIndex}
                  onChange={(event) => setForceIndex(event.currentTarget.checked)}
                  description="Force reindexing of all CVs, even if they haven't changed"
                />
              </Group>
              <Group>
                <Button
                  size="lg"
                  leftSection={
                    <ArrowPathIcon style={{ width: rem(18), height: rem(18) }} />
                  }
                  onClick={handleIndexCVs}
                  loading={isIndexing}
                >
                  Index CVs
                </Button>
              </Group>
              {indexError && (
                <Text color="red" size="sm">
                  {indexError}
                </Text>
              )}
              {indexSuccess && (
                <Text color="green" size="sm">
                  {indexSuccess}
                </Text>
              )}
            </Stack>
          </Paper>
        </Stack>

        <Divider />

        <PromptManagement />
      </Stack>
    </Container>
  );
};
